import {SmartCaptcha} from '@yandex/smart-captcha';
import {useContext} from 'react';

import {CaptchaProvider} from '@shared/Captcha/types';

import {CaptchaContext} from '../CaptchaContext';
import {ProviderProps} from './providerProps';

const provider: CaptchaProvider = 'yandex';

export const YandexCaptcha = ({
  language,
  className,
  onResult,
  onError,
}: ProviderProps) => {
  const {yandexSiteKey} = useContext(CaptchaContext);
  return (
    <div className={className}>
      <SmartCaptcha
        sitekey={yandexSiteKey}
        language={language}
        onSuccess={(token) => onResult({provider, token})}
        onTokenExpired={() => onResult({provider, token: ''})}
        onJavascriptError={onError}
        onNetworkError={onError}
      />
    </div>
  );
};
